import * as React from "react";
import { Button, styled } from "@mui/material";
import { PatientColorMap } from "../../../../layout/patientColorMap";
import { commonBoxShadowStyle } from "fe-common/ui/boxShadow";
import { FeatureFragment, QualifiedFeature } from "fe-common/graphql";
import {
  hasFeatureIcon,
  getFeatureIcon,
} from "fe-common/iconManager/chckIfFeatureHasIcons";
import { SvgLoader } from "react-svgmt";
import { marginRightToMarginLeftOnRtl } from "fe-web-components/rtl/rtlStyles";
import { useEffect, useState } from "react";
import { ReactComponent as DefaultIcon } from "../../../../assets/defualtVisitType.svg";

//region [[ Styles ]]

const VisitTypeSelectionButtonView = styled(Button)({
  "& > span": {
    display: "flex",
    textTransform: "none",
    justifyContent: "flex-start",
    zIndex: 150,
  },
  backgroundColor: PatientColorMap.HomepageLinkColor,
  border: `1px solid ${PatientColorMap.DefaultLight}`,
  borderRadius: "8x",
  ...commonBoxShadowStyle,
  color: PatientColorMap.Default,
  display: "flex",
  flexFlow: "row",
  padding: "21px",
  margin: "5px",
  justifyContent: "flex-start",
});

const VisitTypeTexts = styled("div")({
  display: "flex",
  flexFlow: "column",
  alignItems: "flex-start",
});

const VisitTypeIconContainer = styled("div")({
  ...marginRightToMarginLeftOnRtl(15),
});

// const NoIconSpacer = styled("div")({
//   width: "40px",
//   height: "40px",
//   borderRadius: "7px",
//   color: PatientColorMap.Primary,
//   background: "transparent", //PatientColorMap.Background2,
// });

const VisitTypeName = styled("div")({
  fontWeight: 700,
  fontSize: "14px",
  lineHeight: "18px",
  textAlign: "start",
});

const VisitTypeDescription = styled("div")({
  fontWeight: 400,
  fontSize: "13px",
  lineHeight: "16px",
  textAlign: "start",
  flex: 2,
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface VisitTypeSelectionButtonProps {
  visitType: QualifiedFeature;
  onVisitSelected: (qf: QualifiedFeature) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const VisitTypeSelectionButton = ({
  visitType,
  ...props
}: VisitTypeSelectionButtonProps) => {
  const hasDescription = (feature: FeatureFragment) =>
    !!feature?.patientDescription &&
    feature.patientDescription.trim?.() !== "" &&
    feature.patientDescription.trim?.() !== "N/A";

  const [isIconPresent, setIsIconPresent] = useState(false);

  useEffect(() => {
    hasFeatureIcon(visitType.id).then(setIsIconPresent);
  }, [visitType, setIsIconPresent]);

  return (
    <VisitTypeSelectionButtonView
      onClick={() => props.onVisitSelected(visitType)}
    >
      <VisitTypeIconContainer>
        {isIconPresent && <SvgLoader path={getFeatureIcon(visitType.id)} />}
        {!isIconPresent && <DefaultIcon />}
      </VisitTypeIconContainer>
      <VisitTypeTexts>
        <VisitTypeName className={"visit-type-name"}>
          {visitType.feature.shortname}
        </VisitTypeName>
        {hasDescription(visitType.feature) && (
          <VisitTypeDescription className={"visit-type-desc"}>
            {visitType.feature?.patientDescription ||
              visitType.feature?.description.text}
          </VisitTypeDescription>
        )}
      </VisitTypeTexts>
    </VisitTypeSelectionButtonView>
  );
};
